<template>
  <InfoPageLayout>
    <template #title>{{ t('title') }}</template>
    <p class="leading-7">{{ t('copyright') }}</p>
    <p class="mt-7 leading-7">{{ t('permission') }}</p>
    <PillLink class="mt-10" href="https://www.gnu.org/licenses/gpl-3.0.html" external>{{ t('viewLicense') }}</PillLink>
  </InfoPageLayout>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import InfoPageLayout from '@/components/landingpage/InfoPageLayout.vue'
  import PillLink from '@/components/landingpage/PillLink.vue'

  const { t } = useI18n({
    messages: {
      no: {
        title: 'Programvarelisens',
        copyright: 'Opphavsrett © 2007 Free Software Foundation, Inc. https://fsf.org/',
        permission:
          'Alle har tillatelse til å kopiere og distribuere ordrette kopier av dette lisensdokumentet, men det er ikke tillatt å endre det.',
        viewLicense: 'Se lisens',
      },
      en: {
        title: 'Software licence',
        copyright: 'Copyright © 2007 Free Software Foundation, Inc. https://fsf.org/',
        permission: 'Everyone is permitted to copy and distribute verbatim copies of this license document, but changing it is not allowed.',
        viewLicense: 'View licence',
      },
    },
  })
</script>
